import React from 'react'
import styled from 'styled-components'

import IconButton from 'components/Buttons/IconButton'
import Flex from 'components/Flex'
import Text from 'components/Text'

import Row from './Row'
import { TabularCheckboxData, TabularCheckboxProps } from './types'
import { useState, useEffect } from 'react'

type Props = TabularCheckboxData & {
  groupIndex: number
  isEditing?: boolean
  isDisabled?: boolean
  isAllExpanded?: boolean
  span: number
  onChange?: TabularCheckboxProps['onChange']
  onStateChange: (index: number, isExpanded: boolean) => void
}

const Group: React.FC<Props> = ({ span, subtitle, groupIndex, data, isAllExpanded, onStateChange, ...props }) => {
  const [showRows, setShowRows] = useState<boolean>(isAllExpanded as boolean)

  useEffect(() => {
    setShowRows(isAllExpanded as boolean)
  }, [isAllExpanded])

  const handleStateChange = () => {
    setShowRows(!showRows)
    onStateChange(groupIndex, !showRows)
  }

  return (
    <tbody>
      <Subtitle>
        <td colSpan={span}>
          <Flex alignItems="center" justifyContent="space-between">
            <Text variant="subtitle" lineHeight="2rem">
              {subtitle}
            </Text>
            <IconButton onClick={handleStateChange} icon="angle-down" variant="ghost" />
          </Flex>
        </td>
      </Subtitle>
      {showRows &&
        data.map((row, index) => (
          <Row
            groupIndex={groupIndex}
            {...props}
            {...row}
            key={row.rowId}
            isFirst={index === 0}
            isLast={index === data.length - 1}
          />
        ))}
    </tbody>
  )
}

const Subtitle = styled.tr`
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray4};
  border-top: 1px solid ${({ theme }) => theme.colors.gray4};

  td {
    padding: 0.5rem 2rem;
  }
`

export default Group
